// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
  color: #212529;
  margin-bottom: 1rem;
  width: 100%;
}

.table {
  border-collapse: collapse;
}

.table td,
.table th {
  border-top: 1px solid #dee2e6;
  padding: 0.75rem;
  vertical-align: top;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.text-danger {
  color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/document-upload/document-upload-list/document-upload-list.component.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAIA;EACE,yBAAA;AADF;;AAGA;;EAEE,6BAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAEA;EACE,yBAAA;AACF;;AACA;;EAEE,yBAAA;AAEF;;AACA;EACE,cAAA;AAEF","sourcesContent":["\r\n// @use '~@ascend/styles/ascend' as ascend;\r\n\r\n.table {\r\n  color: #212529;\r\n  margin-bottom: 1rem;\r\n  width: 100%;\r\n}\r\n.table {\r\n  border-collapse: collapse;\r\n}\r\n.table td,\r\n.table th {\r\n  border-top: 1px solid #dee2e6;\r\n  padding: 0.75rem;\r\n  vertical-align: top;\r\n}\r\n.table-bordered {\r\n  border: 1px solid #dee2e6;\r\n}\r\n.table-bordered td,\r\n.table-bordered th {\r\n  border: 1px solid #dee2e6;\r\n}\r\n// TODO: Move to main styles.scss file later\r\n.text-danger {\r\n  color: #dc3545;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
